<template>
  <footer class="my-footer">
    <div class="footer-content">
      <FooterGrid>
        <nav class="nav">
          <AsideStack>
            <a href="/">Home</a>
            <a href="/articles/">Articles</a>
            <a href="/demos/">Demos</a>
            <a href="/tags/">Tags</a>
            <a href="/typography">Typography</a>
            <a href="/splashpage">Splashpage</a>
          </AsideStack>
        </nav>
        <DisclaimerGrid>
          <template #figure>
            <span>copyright</span>
            <strong class="value"
              >&copy;
              <AnimatedNumber :end="currentYear" :start="1990" :duration="1500"
            /></strong>
          </template>
        </DisclaimerGrid>
        <template #side>
          <p>
            <strong>Built with:</strong> VitePress, Vue, TypeScript, SCSS,
            Three.js
          </p>
          <p class="text-vertical">development + strategy</p>
        </template>
      </FooterGrid>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import AnimatedNumber from "../primitives/AnimatedNumber.vue";
import AsideStack from "./AsideStack.vue";
import DisclaimerGrid from "./DisclaimerGrid.vue";
import FooterGrid from "./FooterGrid.vue";

const currentYear = new Date().getFullYear();
</script>

<style scoped lang="scss">
@use "../styles/abstracts/mixins";

.my-footer {
  padding: 6rem 0;
}

.nav {
  font-size: 1.25em;
  line-height: 1.5;
}

.footer-content {
  /* @include mixins.surface; */
  max-width: var(--vp-layout-max-width);
  margin: 0 auto;
  padding: 0 2rem;
}

.value {
  font-weight: bold;
  font-size: var(--font-size-4xl);
}
</style>
